<template>
    <transition name="modal">
        <div v-if="element && !isLoading" class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="container">
                        <div class="modal-header">
                            <div class="row">
                                <div class="col-8">
                                    <h1 v-text="element.$exists ? 'Edit Holiday' : 'Add Holiday'"></h1>
                                </div>
                                <div class="col-auto ml-auto">
                                    <div aria-label="Close modal window" class="modal-default-button fa fa-window-close d-print-none" @click="$emit('close')"></div>
                                </div>
                            </div>
                        </div>


                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md">
                                    <div class="form-group">
                                        <label>Name <span class="required">*</span></label>
                                        <input class="form-control" type="text" v-model="element.name">
                                        <div class="alert alert-danger" v-if="'name' in errors" v-text="errors.name.join()"></div>
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="form-group">
                                        <label>Date <span class="required">*</span></label>
                                        <datepicker v-model="element.date" format="MMM-d-yyyy" :disabled="{days: [6, 0]}"></datepicker>
                                        <div class="alert alert-danger" v-if="'date' in errors" v-text="errors.date.join()"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between d-print-none mt-3">
                                <delete-button v-if="element.$exists" @confirmed="destroyAndClose" title="Delete Holiday">
                                    <p>
                                        Are you sure you want to delete the holiday {{ element.name }}?
                                    </p>
                                </delete-button>
                                <div class="ml-auto">
                                    <button aria-label="Close Holiday Modal window" class="btn btn-medium" @click="$emit('close')">Cancel</button>
                            
                                    <button class="btn btn-primary" @click="saveAndClose" v-text="element.$exists ? 'Update' : 'Save'"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import ElementOperations from './helpers/ElementOperations';
import Datepicker from 'vuejs-datepicker';
import deleteButton from './DeleteButton';
import { ElementComponent } from 'clockvine-vue';

export default {
    props: ['id'],

    components: {
        Datepicker,
        deleteButton,
    },

    mixins: [
        ElementComponent.for('holidays').with({
            computed: {
                newElement: () => ({})
            }
        }),
        ElementOperations
    ],

    methods: {
        saveAndClose() {
            this.save().then(() => {
                this.$emit('close');
            });
        },

        destroyAndClose() {
            this.delete().then(() => {
                this.$emit('close');
            });
        },

    },
}
</script>
